export const GET_PAYSLIPS = 'GET_PAYSLIPS'
export const SET_VIEWED = 'SET_VIEWED'
export const SET_VIEWED_ALL = 'SET_VIEWED_ALL'
export const GET_FILTER_POSITIONS = 'GET_FILTER_POSITIONS'
